import { render, staticRenderFns } from "./ResourceView.vue?vue&type=template&id=4f14fa5f&scoped=true"
import script from "./ResourceView.vue?vue&type=script&lang=js"
export * from "./ResourceView.vue?vue&type=script&lang=js"
import style0 from "./ResourceView.vue?vue&type=style&index=0&id=4f14fa5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f14fa5f",
  null
  
)

export default component.exports